import standaloneRoutes from './standalone'
import consoleRoutes from './console'

export default [
  ...standaloneRoutes,
  ...consoleRoutes,
]
